let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("liZg3")).then(() => parcelRequire('8sngz'));